import React from 'react';
import BaseField from "./BaseField";

export default class FieldBoolean extends BaseField<any, any> {
    static defaultProps = {
        renderLabel: true
    }
    private readonly labelRef: React.RefObject<any>;

    constructor(props: any) {
        super(props)

        this.labelRef = React.createRef()
        this.state = {
            checked: props.value,
            onlyYesOption: this.props.onlyYesOption
        }
    }

    UNSAFE_componentWillReceiveProps(nextProps: any) {
        this.setState({checked: nextProps.value})
    }

    renderField() {
        return (
            <div className={this.getClassNames()}>
                <div className="step-input-field">
                    {this.renderLabel() && <div className="label">
                        {this.getLabel()}
                    </div>}
                    <div className="input">
                        <div className="common-input-wrapper boolean-input-buttons">
                            {this.renderInput()}
                        </div>
                    </div>
                    {this.renderDescription()}
                    {this.renderErrorMessage()}
                </div>
            </div>

        )
    }

    markBoolean = (checked: boolean) => {
        if (this.props.readonly)
            return;

        this.setState({checked: checked})
        this.props.onChange(checked)
    }

    private renderInput() {
        if (this.props.readonly) {
            return <React.Fragment>
                {this.state.checked ? __("Yes") : __("No")}
            </React.Fragment>
        }
        return <React.Fragment>
            <div onClick={() => this.markBoolean(true)}
                 className={`boolean-button ${this.state.checked ? 'checked' : ''}`}>{__("Yes")}</div>
            {!this.state.onlyYesOption && <div onClick={() => this.markBoolean(false)}
                                               className={`boolean-button ${!this.state.checked ? 'checked' : ''}`}>{__("No")}</div>}
        </React.Fragment>
    }
}